import { Check, Copy } from 'lucide-react';
import { type FC, useState } from 'react';
import { useOpenMeetingLink } from '../../../../hooks/useOpenMeetingLink';
import { getMeetingUrl } from '../../../../utils/environment';
import { isPlainLeftClick } from '../../../../utils/meetingLinkRouting';
import { HIDE_LINK_TIMEOUT } from '../../helpers/constants';
import type { JoinLinkSectionProps } from '../../types';

const JoinLinkSection: FC<JoinLinkSectionProps> = ({ room }) => {
  const [copied, setCopied] = useState(false);
  const openMeetingLink = useOpenMeetingLink();

  const handleCopyLink = (meetingLink: string) => {
    navigator.clipboard.writeText(meetingLink);
    setCopied(true);
    setTimeout(() => setCopied(false), HIDE_LINK_TIMEOUT);
  };

  const meetingLink = getMeetingUrl(room);

  return (
    <>
      <div className="schedule-meeting-modal__divider" />
      <div className="schedule-meeting-modal__join-section">
        <div className="schedule-meeting-modal__input-label">Join meeting</div>
        <div className="schedule-meeting-modal__join-link-container">
          <a
            href={meetingLink}
            className="schedule-meeting-modal__join-link"
            aria-label={`Join meeting link: ${meetingLink}`}
            onClick={(event) => {
              if (!isPlainLeftClick(event)) {
                return;
              }
              event.preventDefault();
              openMeetingLink(meetingLink);
            }}
          >
            {meetingLink}
          </a>
          <button
            type="button"
            className="schedule-meeting-modal__copy-button"
            onClick={() => handleCopyLink(meetingLink)}
            aria-label="Copy meeting link"
          >
            {copied ? <Check size={16} /> : <Copy size={16} />}
            {copied ? 'Copied!' : 'Copy link'}
          </button>
        </div>
      </div>
    </>
  );
};

export default JoinLinkSection;
